import React, { useContext } from 'react';
import { useDrag, DragPreviewImage } from 'react-dnd-cjs';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import { getInfoToDisplayImageDeviation } from '../DeviationViews/Dumbo/Image/_helpers';
import { DraggableType } from '../types/dnd';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationMediaService from '../utils/DeviationMediaService';
export default function useDeviationDrag({ deviation, width, height }) {
    const isMobile = useContext(MobileContext);
    const { isLoggedIn } = useContext(SessionContext);
    const [, drag, preview] = useDrag({
        item: {
            type: DraggableType.DEVIATION,
            deviation
        },
        // !! to prevent any undefineds sneaking through and enabling this by mistake
        canDrag: !!(isLoggedIn && !isMobile)
    });
    const type = getDeviationType(deviation);
    let dragPreview = undefined;
    switch(type){
        case DeviationTypes.IMAGE:
            const info = getInfoToDisplayImageDeviation({
                deviation,
                width,
                height
            });
            if (info) {
                dragPreview = /*#__PURE__*/ React.createElement(DragPreviewImage, {
                    connect: preview,
                    src: info.pickedImage.src
                });
            }
            break;
        case DeviationTypes.FILM:
            if (width && height) {
                const file = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, width, height);
                if (file) {
                    dragPreview = /*#__PURE__*/ React.createElement(DragPreviewImage, {
                        connect: preview,
                        src: file.src
                    });
                }
            }
            break;
        default:
    }
    return {
        dragPreview,
        drag
    };
}
